import Image from "components/Elements/Image/Image";
import styles from "../thanksActionModals.module.scss";

const AnimationSection = () => {
  return (
    <div className={styles.imagesWrap}>
      <Image name="mark-done" ext="png" className={styles.markIcon}></Image>
      <Image
        name="emoji-success-1"
        ext="png"
        className={styles.emojiIcon1}
      ></Image>
      <Image
        name="emoji-success-2"
        ext="png"
        className={styles.emojiIcon2}
      ></Image>
      <div className={styles.confetiWrap}>
        <Image name="confeti" ext="png" className={styles.confetiImg}></Image>
      </div>
      <Image name="cloud_success" ext="svg" className={styles.cloudImg}></Image>
      <Image
        name="cloud_shadow_success"
        ext="svg"
        className={styles.cloudShadowImg}
      ></Image>

      <Image name="features/logo" ext="svg" className={styles.logoIcon}></Image>
    </div>
  );
};
export default AnimationSection;
